import {HttpContextToken} from '@angular/common/http';

export const shortDaysOfWeek: string[] = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const GOOGLE_MAPS_API: string = 'AIzaSyBWkLUfYRWdNJuWwqlPCqxTZyfbWn5nxxk';

const NAME_END_CHARACTERS: string = 'A-Za-zÁáÀàÃãÄäÂâÉéÈèËëÊêÍíÌìÏïÎîÓóÒòÕõÖöÔôÚúÙùÜüÛûÇç’ñ.\\-/\'';
const NAME_MIDDLE_CHARACTERS: string = `${NAME_END_CHARACTERS} `;
export const PERSON_NAME_PATTERN: string = `(([${NAME_END_CHARACTERS}])|([${NAME_END_CHARACTERS}][${NAME_MIDDLE_CHARACTERS}]*[${NAME_END_CHARACTERS}]))`;
// eslint-disable-next-line max-len
export const PHONE_PATTERN: string = '(?:(?:(\\s*\\(?([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\)?\\s*(?:[.-]\\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})';
export const ACCOUNT_NUMBER_PATTERN: string = '[a-zA-Z0-9.\\-]*';
export const ADDRESS_PATTERN: string = '[A-Za-zÁáÀàÃãÄäÂâÉéÈèËëÊêÍíÌìÏïÎîÓóÒòÕõÖöÔôÚúÙùÜüÛûÇç’ñ0-9 .\\-\']*';
export const POSTAL_PATTERN: string = '^([A-Za-z]\\d[A-Za-z][-]?\\d[A-Za-z]\\d)';
export const EMPLOYER_PATTERN: string = '[A-Za-zÁáÀàÃãÄäÂâÉéÈèËëÊêÍíÌìÏïÎîÓóÒòÕõÖöÔôÚúÙùÜüÛûÇç’ñ&0-9 .\\-/\']*';
export const FOUR_DIGITS_PATTERN: string = '\\d{4}';
export const IP_PATTERN: string = '^((25[0-5]|(2[0-4]|1[0-9]|[1-9]|)[0-9])(\\.(?!$)|$)){4}$';

export const I18N_CACHE_KEY = 'i18n-set-language';

export const BUSINESS_REQUEST_CACHE_KEY = 'business-request';
export const BUSINESS_RESPONSE_CACHE_KEY = 'business-response';
export const CONSUMER_REQUEST_CACHE_KEY = 'consumer-request';
export const CONSUMER_RESPONSE_CACHE_KEY = 'consumer-response';
export const IFS_REQUEST_CACHE_KEY = 'ifs-request';
export const IFS_RESPONSE_CACHE_KEY = 'ifs-response';
export const MDS_REQUEST_CACHE_KEY = 'mds-request';
export const EAML_REQUEST_CACHE_KEY = 'eaml-request';
export const EAML_RESPONSE_CACHE_KEY = 'eaml-response';

export const IFS_PREFIX = 'IFS - ';
export const IDX_PREFIX = 'IDX - ';

/**
 * Used to control request forms for a selected branch
 */
export const PRODUCT_CODES = {
  mds:         ['02200', '02201', '02300', '02301', '02302', '02303'],
  modelReport: ['08000'],
  idReport:    ['07760'],
  intact:      ['09913']
};

/**
 * Used to identify if a branch has the required products to display Enhanced AML.  Must have both.
 *                                 AML      HRFA
 *                                  |        |
 */
export const EAML_PRODUCT_CODES = ['09800', '06500'];

export const JWT_TYPE_HEADER = 'Jwt-Type';
export const BYPASS_ERROR_INTERCEPTOR = new HttpContextToken(() => false);

//See: https://wiki.transunion.com/display/GTCA/TUD+Roles
export const ROLES = {
  /** Base Role */
  base: ['ROLE_TUDIRECT'],
  /** Normal User */
  regularUser: ['ROLE_TUDESKTOPUSER', 'ROLE_TUD9EAS', 'ROLE_TUD9ENABLE', 'ROLE_TUD9BUSSOL', 'ROLE_TUD9HR', 'ROLE_TUD9COMP', 'ROLE_TUD9CS'],
  /** TU Admin / Super Admin */
  tuAdmin: ['ROLE_TUDESKTOPADMINSECONDARY', 'ROLE_TUC-TUDIRECT-ADMIN-OPERATOR', 'ROLE_TUC-TUDIRECT-UAT-ADMIN-OPERATOR'],
  /** Admin for a specific company */
  companyAdmin: ['ROLE_TUDESKTOPADMINPRIMARY'],
  /** 
   * Operator / Password Reset
   * These two roles are only able to reset passwords and look up users in a company and view user info (but can't edit any of it)
   */
  operator: ['ROLE_TUDESKTOP_PERMISSION_RESET', 'ROLE_TUC-TUDIRECT-OPERATOR', 'ROLE_TUC-TUDIRECT-UAT-OPERATOR']
};

export const CREDIT_SUMMARY_DETAIL_ORDER = ['R', 'O', 'I', 'M', 'T'];
